module.exports = __webpack_public_path__ + "static/img/qbu88.4450c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/qbu88.png
// module id = Nf9r
// module chunks = 1